import React, { useState, useEffect } from 'react';
import ApiService from '../../../../services/apiService';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const FlashSaleReport = () => {
  const [data, setData] = useState([]);
  const [overallTotal, setOverallTotal] = useState(0);
  const [pagination, setPagination] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  // Format date YYYY-MM-DD
  const getFormattedDate = (date) => date.toISOString().slice(0, 10);

  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  const cleanNumber = (val) => {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  };

  // 🔹 Fetch Branch List
  const fetchBranches = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_BRANCH');
      const list = res?.data?.result || [];

      const mapped = list.map((b) => ({
        value: b.id,
        label: b.branchName,
      }));

      setBranches(mapped);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  // 🔹 Fetch Flash Sale Report
  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();

      params.append('ReportType', 'Flash Sale');
      params.append('Measure', 'Revenue');
      params.append('StartDate', formData.fromDate);
      params.append('EndDate', formData.toDate);
      params.append('Comparison', 'No Comparison');
      params.append('BranchId', selectedBranch?.value || 0); // send 0 = all branches

      const res = await apiService.getApiParamater('GET_SALE_SUMMERY', `?${params.toString()}`);

      const raw = res?.data?.result || [];
      setPagination(res?.data?.paginationData);

      // Normalize backend fields
      const mapped = raw.map((row) => ({
        branchName: row['Branch Name'],
        totalSales: cleanNumber(row['Total Sales']),
      }));

      // Extract TOTAL row if included
      const totalRow = mapped.find((r) => (r.branchName || '').toUpperCase() === 'TOTAL SALES');

      const branchRows = mapped.filter((r) => (r.branchName || '').toUpperCase() !== 'TOTAL SALES');

      // If API doesn't send a TOTAL row, compute it
      const computedTotal = totalRow?.totalSales ?? branchRows.reduce((sum, r) => sum + cleanNumber(r.totalSales), 0);

      // Optional client-side filter if API ignores BranchId
      const filteredRows = selectedBranch ? branchRows.filter((r) => r.branchName === selectedBranch.label) : branchRows;

      setData(filteredRows);
      setOverallTotal(computedTotal);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const totalBranches = data.length;
  const activeBranches = data.filter((r) => r.totalSales > 0).length;
  const filteredTotal = data.reduce((sum, r) => sum + cleanNumber(r.totalSales), 0);

  return (
    <div className="p-5">
      <button className="addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      {/* <h3 className="mb-4">
        {t('flash')} {t('sale')} {t('report')}
      </h3> */}

      {/* 🔹 Filters */}
      <div className="row mb-4">
        <div className="col-md-4 mb-3">
          <label className="form-label">{t('Branch') || 'Branch'}</label>
          <Select
            value={selectedBranch}
            onChange={(opt) => setSelectedBranch(opt)}
            options={branches}
            placeholder={t('select') + ' ' + (t('branch') || 'Branch')}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              menu: (base) => ({ ...base, zIndex: 999999 }),
            }}
            isClearable
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">
            {t('From')} {t('Date')}
          </label>
          <input type="date" className="form-control" value={formData.fromDate} name="fromDate" onChange={handleInputChange} />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">
            {t('To')} {t('Date')}
          </label>
          <input type="date" className="form-control" value={formData.toDate} name="toDate" onChange={handleInputChange} />
        </div>

        <div className="col-md-2 d-flex align-items-end mb-3">
          <button className="addItem-btn w-100" onClick={getReportData}>
            {t('search')}
          </button>
        </div>
      </div>

      {/* 🔹 Summary Cards */}
      {/* <div className="row g-3 mb-4">
        {/* <div className="col-md-4">
          <div className="POsgridshad rounded p-3">
            <div className="text-muted small">
              {t('Total')} {t('sales')}
            </div>
            <div className="h4 mb-0">{overallTotal.toFixed(2)}</div>
          </div>
        </div> */}
      {/* 
        <div className="col-md-4">
          <div className="POsgridshad rounded p-3">
            <div className="text-muted small">
              {t('Total')} {t('Branches')}
            </div>
            <div className="h4 mb-0">{totalBranches}</div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="POsgridshad rounded p-3">
            <div className="text-muted small">
              {t('Active')} {t('branches')}
            </div>
            <div className="h4 mb-0">{activeBranches}</div>
          </div>
        </div>
      </div>  */}

      {/* 🔹 Table */}
      <div className="POsgridshad rounded p-4">
        <div className="custom-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th className="text-left">{t('Branch') || 'Branch'}</th>
                <th className="text-end">
                  {t('Total')} {t('Sales')}
                </th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={2} className="text-center">
                    {t('No Data') || 'No data found'}
                  </td>
                </tr>
              ) : (
                data.map((item, idx) => (
                  <tr key={idx}>
                    <td className="text-left">{item.branchName}</td>
                    <td className="text-end">{item.totalSales.toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>

            <tfoot>
              <tr className="bg-green-100 font-bold">
                <td className="text-end">
                  {t('Total')} {t('Sales')} ({t('Filtered')})
                </td>
                <td className="text-end">{filteredTotal.toFixed(2)}</td>
              </tr>
              {/* 
              <tr className="bg-green-100 font-bold">
                <td className="text-end">
                  {t('Grand')} {t('Total')}
                </td>
                <td className="text-end">{overallTotal.toFixed(2)}</td>
              </tr> */}
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FlashSaleReport;
